import { NumbersOnlyDirective } from './../../directives/number-only.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoFocusDirective } from '@directives/autofocus.directive';
import { LettersOnlyDirective } from '@directives/letters-only.directive';
import { RutDirective } from '@directives/rut.directive';
import { DropdownLoadingDirective } from '@directives/dropdown-loading.directive';
import { AlphaNumericDirective } from '@directives/alpha-numeric.directive';
import { ScrollToBottomDirective } from '@directives/scroll-to-bottom.directive';
import { DisableLinkDirective } from '@directives/disable-link.directive';
import { FormatRutPipe } from '@pipes/format-rut.pipe';
import { DeduciblePipe } from '@pipes/deducible.pipe';
import { DotToCommaPipe } from '@pipes/dot-to-comma.pipe';
import { AutoFocusDropdownDirective } from '@directives/autofocus-dropdown.directive';
import { UpperLowerPipe } from '@pipes/upperlower.pipe';
import { MontoAseguradoPipe } from '@pipes/monto-asegurado.pipe';
import { TrimStartPipe } from '@pipes/trim-start.pipe';
import { ShowErrorValuePipe } from '@pipes/show-error-value.pipe';
import { LetterNumberDotDirective } from '@directives/letterNumberDot.directive';

@NgModule({
  declarations: [
    AutoFocusDirective,
    LettersOnlyDirective,
    NumbersOnlyDirective,
    RutDirective,
    DropdownLoadingDirective,
    AlphaNumericDirective,
    ScrollToBottomDirective,
    DisableLinkDirective,
    FormatRutPipe,
    DeduciblePipe,
    DotToCommaPipe,
    AutoFocusDropdownDirective,
    UpperLowerPipe,
    MontoAseguradoPipe,
    TrimStartPipe,
    ShowErrorValuePipe,
    LetterNumberDotDirective
  ],
  imports: [CommonModule],
  exports: [
    InputTextModule,
    ProgressBarModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    CheckboxModule,
    DialogModule,
    RadioButtonModule,
    TabViewModule,
    TableModule,
    AccordionModule,
    ReactiveFormsModule,
    FormsModule,
    AutoFocusDirective,
    LettersOnlyDirective,
    NumbersOnlyDirective,
    RutDirective,
    DropdownLoadingDirective,
    AlphaNumericDirective,
    ScrollToBottomDirective,
    DisableLinkDirective,
    FormatRutPipe,
    DeduciblePipe,
    DotToCommaPipe,
    UpperLowerPipe,
    AutoFocusDropdownDirective,
    MontoAseguradoPipe,
    TrimStartPipe,
    ShowErrorValuePipe,
    LetterNumberDotDirective
  ],
})
export class PrimeNGModule {}
